import axios from 'axios';
import store from '@/store'
import router from '@/router'
import { Message,Loading } from 'element-ui';
import { apiRefresh } from '@/request/api';

var qs = require('qs');
const BEARER = 'Bearer ';
let loading;
let needLoadingRequestCount = 0;
function startLoading() {
    loading = Loading.service({
        background: 'rgba(255, 255, 255, 0.4)'
    });
}
function endLoading() {
    loading.close();
}
function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading();
    }
    needLoadingRequestCount++;
}

function hideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return;
    needLoadingRequestCount--;
    if (needLoadingRequestCount === 0) {
        endLoading();
    }
}

axios.defaults.timeout = 90000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.baseURL = window.location.protocol + process.env.API_ROOT;

axios.interceptors.request.use((config) => {
    if(store.state.refreshToken && config.url == '/cmsauth/refresh'){
        config.headers.common['ReAuthorization'] = BEARER + store.state.refreshToken;
    }
    if(store.state.token && config.url != '/cmsauth/refresh'){
        config.headers.common['Authorization'] = BEARER + store.state.token;
    }
    if(config.url != '/cmspush/findMember'){
        showFullScreenLoading();        
    }
    if (config.method === 'get') {
        // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2,不转换会显示为arr[]=1&arr[]=2
        config.paramsSerializer = function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat',encode:false })
        }
    }
    return config;
},(error) =>{
    hideFullScreenLoading();
    Message.error('System busy!');
    return Promise.reject(error);
});

axios.interceptors.response.use((res) =>{
    hideFullScreenLoading();
    if(res && res.status == 200 && res.data.status == 'L101'){
        Message.error(res.data.msg);
        store.dispatch("UserLogout");
        router.push('/login');
    }else{  
        return res;
    }
}, (error) => {
    hideFullScreenLoading();
    if(error.message === 'Network Error'){
        Message.error('Network Error');
    }else if(error.message.includes('timeout')){
        Message.error('Connection Timeout');
    }
    else{
        if(error.response.status&&error.response.status == 403){
            Message.error('No permission!');
        }else{
            Message.error('System busy!');
        }
        return Promise.reject(error);
    }
});

function judgeFetch(url,callback){
    if(url != '/cmsauth/login' && url != '/cmsauth/refresh'){
        let currentTime = Date.parse(new Date()) / 1000;
        if(currentTime > store.state.expireTime){
            apiRefresh().then(res => {
                if(res && res.status == 200 && res.data.status == '00'){
                    store.dispatch("UserLogin", res.data.payload.accessToken);
                    let userInfo = {};
                    userInfo.menus = res.data.payload.menus;
                    userInfo.permissions = res.data.payload.permissions;
                    userInfo.username = res.data.payload.username;
                    userInfo.refreshToken = res.data.payload.refreshToken;
                    userInfo.expireTime = Date.parse(new Date()) / 1000 + res.data.payload.expireTime;
                    store.dispatch("UserInfo", JSON.stringify(userInfo));
                    callback();
                }
            })
        }else{
            callback();
        }
    }else{
        callback();
    }
}

export function fetchPost(url, params) {
    return new Promise((resolve, reject) => {
        //judgeFetch(url,function(){
            axios.post(url, params)
                .then(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                })
                .catch((error) => {
                    reject(error)
                })
        //})
    })
}

export function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        //judgeFetch(url,function(){
            axios.get(url, {params: param})
                .then(response => {
                    resolve(response)
                }, err => {
                    reject(err)
                })
                .catch((error) => {
                    reject(error)
                })
        //}) 
    })
}

export function fetchPut(url, params) {
    return new Promise((resolve, reject) => {
        //judgeFetch(url,function(){
            axios.put(url, params)
                .then(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                })
                .catch((error) => {
                    reject(error)
                })
        //})
    })
}

export function fetchDelete(url) {
    return new Promise((resolve, reject) => {
        //judgeFetch(url,function(){
            axios.delete(url)
                .then(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                })
                .catch((error) => {
                    reject(error)
                })
        //})
    })
}

export function fetchDownload(url,params) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'POST',
            url: url,
            params: params,
            responseType: 'blob'
        })
        .then(res => {
            console.log(res)
            if(res.status == 200 &&res.data){
                let data = res.data;
                let contentDisposition = res.headers['content-disposition'];
                let fileName = window.decodeURI(contentDisposition.split("=")[1], "UTF-8");
                executeDownload(data, fileName);
            }else{
                Message.error('Download Failed');
            }
            resolve(res);
        })
    })
}

export function fetchDownloadData(url,data) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'POST',
            url: url,
            data: data,
            responseType: 'blob'
        })
        .then(res => {
            console.log(res)
            if(res.status == 200 &&res.data){
                let data = res.data;
                let contentDisposition = res.headers['content-disposition'];
                let fileName = window.decodeURI(contentDisposition.split("=")[1], "UTF-8");
                executeDownload(data, fileName);
            }else{
                Message.error('Download Failed');
            }
            resolve(res);
        })
    })
}

function executeDownload(data, fileName) {
    if (!data) {
        return
    }
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export default {
    fetchPost,
    fetchGet,
    fetchPut,
    fetchDelete,
}


// WEBPACK FOOTER //
// ./src/request/http.js